import { FC, useState, useCallback } from 'react';

import { Input } from 'src/components/Form/Input';

import styles from './email.module.css';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EmailPage: FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | undefined>();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setEmail(e.target.value);
      setError(undefined);
    },
    []
  );

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      const trimmed = email.trim();
      if (!trimmed) {
        setError('Enter your email');
        return;
      }
      if (!EMAIL_REGEX.test(trimmed)) {
        setError('Enter a valid email address');
        return;
      }
      setError(undefined);
      // TODO: submit email (e.g. API call)
    },
    [email]
  );

  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <img className={styles.logo} src="/logo.svg" alt="Playwall Logo" />

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.inputWrapper}>
            <Input
              name="email"
              type="email"
              label="Email"
              placeholder="you@example.com"
              value={email}
              error={error}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className={styles.button}>
            <span className={styles.buttonLabel}>Submit</span>
          </button>
        </form>
      </div>
    </div>
  );
};
